/**
 * A call's arguments as the approval block shows them: one line a field, so a
 * short field is never hidden behind a long one. A field inside an object has
 * a line of its own too, named by its path. Each value is shown whole, as
 * JSON, in a box of its own that scrolls: the Worker runs the whole of it.
 */

/** `[key, value]` for each field, or null for text that is not a JSON object,
 *  which shows whole. */
export function argumentFields(raw: string): Array<[string, string]> | null {
  let args: unknown;
  try {
    args = JSON.parse(raw);
  } catch {
    return null;
  }
  if (!args || typeof args !== 'object' || Array.isArray(args)) return null;
  const out: Array<[string, string]> = [];
  const walk = (prefix: string, obj: object) => {
    for (const [k, v] of Object.entries(obj)) {
      // Escaped as JSON would write it, so a line break in a key cannot draw
      // a field of its own.
      const key = prefix + JSON.stringify(k).slice(1, -1);
      if (v && typeof v === 'object' && !Array.isArray(v) && Object.keys(v).length) walk(`${key}.`, v);
      else out.push([key, JSON.stringify(v)]);
    }
  };
  walk('', args);
  return out;
}
